const freightForwarderStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
};

module.exports = {
  freightForwarderStatus,
};
